<template>

  <div class="vflex">
    <div class="vflex-row-1">

      <div class="hflex">

        <div class="p-4">
          <h4>Os relatórios 1.0 foram descontinuados.</h4>
          Caso precise baixar dados como "Candidatos contratados" ou "Detalhes de vagas", acesse
          <router-link
            to="/config/dataimex">exportar dados</router-link>.
        </div>


        <div
          v-if="false"
          class="hflex-col-1">
          <router-view></router-view>
        </div>

        <div
          v-if="false"  
          class="hflex-col-0 hflex-options-right"
          :style="{'min-width': (menuOpen?'240px':'25px')}">

          <div
            class="btn-open"
            @click="openMenu()"
            v-if="!menuOpen">
            <i class="fas fa-chevron-left" />
          </div>

          <div v-if="menuOpen">
            <nav
              v-if="permissions.includes('view_simple_report')"
              class="list-group list-group-flush"
              @click="closeMenu()">
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/disqualify-reasons"><i class="fas fa-thumbs-down" /> {{ $t('Disqualify reasons') }}</router-link>-->
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/cancel-reasons"><i class="far fa-window-close" /> {{ $t('Cancel reasons') }}</router-link>-->
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/pipeline-speed"><i class="fas fa-tachometer-alt" /> {{ $t('Pipeline speed') }}</router-link>-->
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/pipeline-conversion"><i class="fas fa-filter" /> {{ $t('Pipeline conversions') }}</router-link>-->
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/time-to-fill"><i class="fas fa-bolt" /> {{ $t('Time to fill') }}</router-link>-->
              <router-link class="list-group-item list-group-item-action" to="/reports/job-details"><i class="fas fa-bars" /> {{ $t('Job details') }}</router-link>0
              <router-link class="list-group-item list-group-item-action" to="/reports/current-pipeline"><i class="fas fa-table" /> {{ $t('Current pipeline') }}</router-link>
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/current-candidate"><i class="fas fa-user" /> Candidatos atuais</router-link>-->
              <router-link class="list-group-item list-group-item-action" to="/reports/hireds"><i class="fas fa-home" /> {{ $t('Hireds') }}</router-link>
              <!--<router-link class="list-group-item list-group-item-action" to="/reports/candidate-source"><i class="fas fa-map-marker-alt" /> {{ $t('Candidates source') }}</router-link>-->
            </nav>
            <div v-if="permissions.includes('view_advanced_report')">
              <div class="p-3"><strong>{{ $t('Advanced') }}</strong></div>
              <nav
                class="list-group list-group-flush"
                @click="closeMenu()">
                <router-link class="list-group-item list-group-item-action" to="/reports/productivity"><i class="fas fa-chart-line" /> {{ $t('Productivity') }}</router-link>
              </nav>
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>

</template>

<script>

export default {
  name: 'ReportList',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    menuOpen () {
      return this.$route.query.menu_open
    }
  },
  metaInfo () {
    return {
      title: this.$t('Reports')
    }
  },
  created () {
  },
  methods: {
    closeMenu () {
      this.$changeUrlParam({
        menu_open: undefined
      })
    },
    openMenu () {
      this.$changeUrlParam({
        menu_open: true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-open{
  background: rgba(0,0,0,0.3);
  width: 25px;
  height: 100%;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportList.vue